import { render, staticRenderFns } from "./Ordinances.vue?vue&type=template&id=5a2b07e8&scoped=true&lang=pug&"
import script from "./Ordinances.vue?vue&type=script&lang=js&"
export * from "./Ordinances.vue?vue&type=script&lang=js&"
import style0 from "./Ordinances.vue?vue&type=style&index=0&id=5a2b07e8&lang=scss&scoped=true&"
import style1 from "./Ordinances.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2b07e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
